module.exports = __webpack_public_path__ + "img/u93.bcd27dea.jpg";